import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    if (!this.element.value) {
      this.element.value = '0.00'
    }
  }

  keydown(event) {
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'Tab', 'Shift', 'Enter']
    if (allowedKeys.includes(event.key)) return

    event.preventDefault()

    if (event.key === 'Delete') {
      this.element.value = '0.00'
      return
    }

    const digits = this.getDigits()

    if (event.key === 'Backspace') {
      this.formatFromDigits(digits.slice(0, -1) || '0')
    } else if (/^\d$/.test(event.key)) {
      this.formatFromDigits(digits + event.key)
    }
  }

  paste(event) {
    event.preventDefault()
    const digits = event.clipboardData.getData('text').replace(/[^\d]/g, '')
    if (digits) {
      this.formatFromDigits(digits)
    }
  }

  getDigits() {
    return (this.element.value || '0.00').replace(/[^\d]/g, '')
  }

  formatFromDigits(digitsString) {
    const digits = digitsString.toString().substring(0, 15).padStart(3, '0')
    const cents = digits.slice(-2)
    const dollars = digits.slice(0, -2).replace(/^0+/, '') || '0'
    const formatted = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    this.element.value = `${formatted}.${cents}`
    this.element.setSelectionRange(this.element.value.length, this.element.value.length)
  }
}
